import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Box, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CustomOurlineAccordian = ({ summary, details }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleToggle = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion
      expanded={expanded}
      sx={{
        boxShadow: "none",
        borderRadius: 1,
        bgcolor: "#fff",
        width: "100%",
        "&::before": { backgroundColor: "transparent" },
        border:"1px solid #4169E1"
      }}
    >
      <AccordionSummary sx={{ position: "relative",borderBottom:expanded?"1px solid #4169E1":"none" }}>
        <Box sx={{ width: "100%", position: "relative" }}>
          {summary}


          <IconButton
            onClick={handleToggle}
            sx={{ position: "absolute", bottom: 0, right: 0 }}
          >
            {!expanded ? <ExpandMoreIcon fontSize="medium" /> : <ExpandLessIcon fontSize="medium" />}
          </IconButton>

        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ px: "2%", position: "relative" }}>
        {details}


      </AccordionDetails>
    </Accordion>
  );
};

export default CustomOurlineAccordian;



